import { ChevronRight, Compass } from "lucide-react"

const HeroBanner = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-[#004aad] to-[#007bff]">
      {/* Tech pattern background */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute top-0 left-0 right-0 bottom-0"
          style={{
            backgroundImage: `
                 radial-gradient(circle at 20% 35%, rgba(255,255,255,0.2) 1px, transparent 1px),
                 radial-gradient(circle at 80% 45%, rgba(255,255,255,0.1) 1px, transparent 1px),
                 radial-gradient(circle at 40% 60%, rgba(255,255,255,0.1) 2px, transparent 2px),
                 radial-gradient(circle at 60% 75%, rgba(255,255,255,0.08) 1px, transparent 1px)
               `,
            backgroundSize: "60px 60px, 80px 80px, 100px 100px, 120px 120px",
          }}
        ></div>
        <div
          className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: `linear-gradient(90deg, transparent 95%, rgba(255,255,255,0.05) 95%),
                                 linear-gradient(0deg, transparent 95%, rgba(255,255,255,0.05) 95%)`,
            backgroundSize: "20px 20px",
          }}
        ></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-1/2 z-10 mb-12 md:mb-0">
            <h1
              className="animate-enter text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-[1.08] tracking-[-0.02em]"
              style={{ animationDelay: "40ms" }}
            >
              Disinformation spreads fast.{" "}
              <span className="relative">
                Facts
                <span className="absolute bottom-1 left-0 w-full h-1 bg-white/30 rounded-full"></span>
              </span>{" "}
              should spread faster.
            </h1>
            <p
              className="animate-enter text-xl md:text-2xl text-white/90 mb-8 max-w-lg"
              style={{ animationDelay: "130ms" }}
            >
              Hasbara.ai detects anti-Israel misinformation and generates accurate, fact-based
              responses in seconds - so no false claim goes unanswered.
            </p>
            <div className="animate-enter flex flex-wrap gap-4" style={{ animationDelay: "220ms" }}>
            <a
              href="#get-started"
              className="press group flex items-center gap-2 bg-white text-[#004aad] px-6 py-3 rounded-full font-semibold shadow-sm transition-[box-shadow,transform] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] hover:shadow-lg hover:shadow-white/20 hover:-translate-y-0.5"
            >
              Try it now
              <ChevronRight className="w-5 h-5 transition-transform duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-1" />
            </a>
              <a
                href="#vision"
                className="press group flex items-center gap-2 bg-transparent text-white border-2 border-white/70 px-6 py-3 rounded-full font-semibold transition-[background-color,border-color] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-white/10 hover:border-white"
              >
                Where we're headed
                <Compass className="w-4 h-4 transition-transform duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-1" />
              </a>
            </div>
          </div>

          <div className="md:w-1/2 flex justify-center md:justify-end z-10">
            <div className="relative">
              <div className="absolute -inset-4 bg-white/10 rounded-full blur-xl animate-pulse"></div>
              <div className="relative animate-float">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 260 300"
                  className="w-48 h-48 md:w-64 md:h-64"
                  style={{
                    filter: "drop-shadow(0 0 20px rgba(255, 255, 255, 0.5))",
                  }}
                >
                  <path fill="white" d="m1,75 129,224 129-224m0,150-129-224-129,224" />
                </svg>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-white/20 rounded-full blur-xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" className="w-full">
          <path
            fill="#ffffff"
            fillOpacity="1"
            d="M0,32L60,42.7C120,53,240,75,360,74.7C480,75,600,53,720,42.7C840,32,960,32,1080,37.3C1200,43,1320,53,1380,58.7L1440,64L1440,100L1380,100C1320,100,1200,100,1080,100C960,100,840,100,720,100C600,100,480,100,360,100C240,100,120,100,60,100L0,100Z"
          ></path>
        </svg>
      </div>
    </div>
  )
}

export default HeroBanner
